import type { DocumentObjectTypes } from '../types';
import type { CMSAssetType } from '~/elc/features/cms';
import { CMSTopLevelContentTypes } from '~/elc/features/cms';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';

type LinkableResult = {
  id: string;
  type: DocumentObjectTypes | CMSTopLevelContentTypes | CMSAssetType;
};

export const getRedirectUrlForSearchResult = (item: LinkableResult) => {
  if (item.type === CMSTopLevelContentTypes.CMS_FILE) {
    return `/cms_files/view?tlc_id=${item.id}`;
  }

  if (item.type === CMSTopLevelContentTypes.CMS_LINK) {
    return `/cms_links/view?tlc_id=${item.id}`;
  }

  const link = AssetPickerTypes.getViewItemUrl({ id: item.id, type: item.type });
  return link;
};
